export default __webpack_public_path__ + "static/media/fifth.5211335e6cb98d76890a6c2c4dab52c3.svg";